import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

const OfflineIndicator = () => {
    const [showOnlineToast, setShowOnlineToast] = useState(false);
    const [showOfflineToast, setShowOfflineToast] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setShowOfflineToast(false);
            setShowOnlineToast(true);

            // Auto-hide online toast after 4 seconds
            setTimeout(() => {
                setShowOnlineToast(false);
            }, 4000);
        };

        const handleOffline = () => {
            setShowOnlineToast(false);
            setShowOfflineToast(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    // Don't show anything if both toasts are hidden
    if (!showOfflineToast && !showOnlineToast) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            aria-atomic="true"
            className={`fixed bottom-20 left-1/2 -translate-x-1/2 z-[100] px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 transition-all duration-300 ${showOnlineToast
                ? 'bg-emerald-600 animate-in fade-in slide-in-from-bottom-4'
                : 'bg-red-600 animate-in fade-in slide-in-from-bottom-4'
                }`}
        >
            {showOnlineToast ? (
                <>
                    <Wifi size={18} className="text-white" aria-hidden="true" />
                    <span className="text-white font-bold text-sm">
                        ✅ Conectado
                    </span>
                </>
            ) : (
                <>
                    <WifiOff size={18} className="text-white" aria-hidden="true" />
                    <span className="text-white font-bold text-sm">
                        ⚠️ Sin conexión - Modo Offline
                    </span>
                </>
            )}
        </div>
    );
};

export default OfflineIndicator;
